/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyChatActivityLastMessage_ChatActivity = {
    readonly lastMessage: {
        readonly " $fragmentRefs": FragmentRefs<"TypographyMessageText_Message">;
    } | null;
    readonly " $refType": "TypographyChatActivityLastMessage_ChatActivity";
};
export type TypographyChatActivityLastMessage_ChatActivity$data = TypographyChatActivityLastMessage_ChatActivity;
export type TypographyChatActivityLastMessage_ChatActivity$key = {
    readonly " $data"?: TypographyChatActivityLastMessage_ChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityLastMessage_ChatActivity">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyChatActivityLastMessage_ChatActivity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Message",
      "kind": "LinkedField",
      "name": "lastMessage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TypographyMessageText_Message"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
(node as any).hash = '8e065120cd8203f24c4169f61e5fe764';
export default node;
